<div style="text-align: center; margin-top: 100px; margin-bottom: 100px; padding: 15px">
  <div style="aspect-ratio: 16/9; width: 100%; background-color: #eee; margin: auto; border-radius: 2em; overflow: hidden;">
    <img src="/../assets/img/landing-page/menu-numerique.jpg" alt="Photo menu numérique" style="width: 100%">
  </div>
</div>
